// extracted by mini-css-extract-plugin
module.exports = {"fieldOfStudyListWrapper":"styles_fieldOfStudyListWrapper__1bjpe","fieldOfStudyList":"styles_fieldOfStudyList__3wkVO"};